var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoginIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0070CC",
    d: "M15.8251 5.5714h2.5499c.7053 0 1.2751.5746 1.2751 1.2857V17.143c0 .7111-.5698 1.2857-1.2751 1.2857h-2.5499c-.7053 0-1.2751.5745-1.2751 1.2857 0 .7111.5698 1.2857 1.2751 1.2857h2.5499c2.1118 0 3.8251-1.7277 3.8251-3.8571V6.8571C22.2001 4.7277 20.4868 3 18.375 3h-2.5499c-.7053 0-1.2751.5745-1.2751 1.2857s.5698 1.2857 1.2751 1.2857m-.3746 7.3366c.4981-.5022.4981-1.3178 0-1.8201l-5.1-5.1428a1.2694 1.2694 0 0 0-1.8049 0c-.498.5022-.498 1.3179 0 1.82l2.9245 2.9492h-8.395c-.7053 0-1.275.5745-1.275 1.2857s.5697 1.2857 1.275 1.2857h8.395l-2.9245 2.9491c-.498.5023-.498 1.3179 0 1.8201a1.2695 1.2695 0 0 0 1.8049 0l5.1-5.1428z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoginIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/login-icon.3ae6fd3c1252ed04ab4b4208894fae69.svg";